import { equalStrictValue } from '@helpers/validator';
import { validatePassword } from 'helpers/passwordForm';

const Schema = {
  password: {
    type: 'password',
    isValid: [(value) => validatePassword(value).totalValid],
  },
  repeatPassword: {
    type: 'password',
    errorMessage: ['errors.password.confirmRequired', 'errors.password.errorPassword'],
    optionalvalue: 'password',
    isValid: [
      (value) => value.length > 0,
      (value, optionalValue) => equalStrictValue(value, optionalValue),
    ],
  },
};

export default Schema;
